import { FC, useState } from 'react';

import { UserOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Avatar, Button, Dropdown, Layout, Menu } from 'antd';
import { Link, useNavigate } from 'react-router-dom';

import styles from './Header.module.scss';
import { routeNames } from '../../constants/routes';
import PermissionWrapper from '../../hoc/PermissionWrapper';
import { useActions } from '../../hooks/useActions';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import SchoolModal from '../nav/components/Modal';
export const endImpersonation = () => {
  localStorage.setItem('access', localStorage.getItem('access_admin')!);
  localStorage.removeItem('access_admin');
  window.location.href = '/crm/users';
};
const Header: FC = () => {
  const navigate = useNavigate();

  const { authLogout, setActiveMainTab } = useActions();
  const { name, role } = useTypedSelector((state) => state.currentUser);
  const { userAccess, selectedSchool, schoolList } = useTypedSelector(
    (state) => state.currentSchool
  );
  const { currentSchoolChange, fetchUserAndSchoolInfo } = useActions();

  const [isModalVisible, setIsModalVisible] = useState(false);

  const userMenuItems = [
    {
      key: '1',
      label: <Link to={routeNames.profile}>Профиль</Link>,
    },
    {
      key: '2',
      label: <span>Выход</span>,
      onClick: () =>
        authLogout(() => {
          navigate(routeNames.login);
        }),
    },
    localStorage.getItem('access_admin')
      ? {
        key: '3',
        label: <span>Выйти из пользователя</span>,
        onClick: () => endImpersonation(),
      }
      : null,
  ];

  const crmMenuItems = [
    {
      key: 'analytics',
      label: <Link to={routeNames.crmAnalytics}>Аналитика</Link>,
    },
    {
      key: '1',
      label: <Link to={routeNames.crmSchool}>Школы</Link>,
    },
    {
      key: '2',
      label: <Link to={routeNames.crmUsers}>Пользователи</Link>,
    },
    {
      key: '3',
      label: <Link to={routeNames.crmOrders}>Заказы</Link>,
    },
    {
      key: '4',
      label: <Link to={routeNames.crmPayments}>Платежи</Link>,
    },
    {
      key: '5',
      label: <Link to={routeNames.crmTariffs}>Тарифы</Link>,
    },
    {
      key: '6',
      label: <Link to={routeNames.crmActivity}>Активность</Link>,
    },
    {
      key: '7',
      label: <Link to={routeNames.crmDetails}>Детализация</Link>,
    },
    {
      key: '8',
      label: <Link to={routeNames.crmPartner}>Партнёрская программа</Link>,
    },
    {
      key: '9',
      label: <Link to={routeNames.crmRequests}>Запросы</Link>,
    },
  ];

  const changeSchool = (id: string) => {
    currentSchoolChange(id, () => {
      fetchUserAndSchoolInfo(navigate);
      window.location.reload();
    });
  };

  const handleSchoolClick = () => {
    setIsModalVisible(true); // Открываем модальное окно при клике на школу
  };

  return (
    <Layout.Header className={styles.headerContainer}>
      <div>
        <Link
          to="/"
          className={styles.logoWrapper}
          onClick={() => setActiveMainTab('overview')}
        >
          <img style={{ width: '165px' }} alt="SCAN" src="/logo.png" />
        </Link>
        <div className={styles.schoolSelectorWrapper}>
          <Menu
            className={styles.schoolName}
            style={{
              borderRadius: '30px',
              textAlign: 'center',
              background: 'none',
            }}
            mode="inline"
            selectable={false}
            items={[
              {
                key: 'school-selector',
                label: (
                  <span
                    data-help-id="header-school-selector"
                    onClick={(e) => {
                      handleSchoolClick();
                      e.currentTarget.blur();
                    }}
                    style={{
                      cursor: 'pointer',
                      fontSize: '16px',
                      paddingLeft: '17px',
                    }}
                  >
                    {selectedSchool?.name || 'Выберите школу'}
                    {selectedSchool?.id && (
                      <span style={{ fontSize: '15px', marginLeft: 5, opacity: 0.4 }}>
                        - {selectedSchool.id}
                      </span>
                    )}
                  </span>
                ),
              }
            ]}
          />
        </div>
        {/* <SchoolDropdowns/> */}
      </div>

      <div>
        <div
          style={{
            marginRight: 25,
          }}
          className={styles.headerBill}
        >
          <a
            data-help-id="header-instruction"
            href="https://doc.scananalytics.ru/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.instructionLink}
          >
            <QuestionCircleOutlined />
            Инструкция
          </a>
          {role === 'superadmin' && <Dropdown
            menu={{ items: crmMenuItems }}
            placement="bottom"
            trigger={['click']}
          >
            <Button
              data-help-id="header-crm"
              type="primary"
              style={{
                padding: '2px 10px',
                backgroundColor: 'white',
                color: 'black',
                borderColor: 'black',
                borderRadius: '5px',
                marginRight: '10px'
              }}
            >
              CRM
            </Button>
          </Dropdown>}
          <Button
            data-help-id="header-support"
            type="primary"
            style={{
              padding: '2px 10px',
              marginRight: 12,
              borderRadius: '5px',
            }}
          >
            <a href="https://t.me/analytics_scan" target="_blank">
              Написать в поддержку
            </a>
          </Button>
          {selectedSchool && (
            <PermissionWrapper
              allowedRoles={['owner', 'employee']}
              redirectToErrPage={false}
              returnedElement={<div />}
            >
              <Button
                data-help-id="header-billing"
                type="primary"
                style={{
                  padding: '2px 10px',
                  backgroundColor: 'white',
                  color: 'black',
                  borderColor: 'black',
                  borderRadius: '5px',
                }}
              >
                <Link to={routeNames.bill}>Биллинг</Link>
              </Button>
            </PermissionWrapper>
          )}
        </div>

        {selectedSchool && (
          <PermissionWrapper
            allowedRoles={['owner', 'employee']}
            redirectToErrPage={false}
            returnedElement={<div />}
          >
            <Link data-help-id="header-license" className={styles.licenceInfo} to={routeNames.bill}>
              <p>Доступ до {userAccess?.date || '-'}</p>
              <p>Осталось {userAccess?.days || '0'} дней</p>
            </Link>
          </PermissionWrapper>
        )}

        <Dropdown
          menu={{ items: userMenuItems }}
          placement="bottom"
          trigger={['click']}
        >
          <div data-help-id="header-user-menu" className={styles.userInfo}>
            <Avatar size="default" icon={<UserOutlined />} />
            <span>{name || 'Пользователь'}</span>
          </div>
        </Dropdown>
      </div>
      <SchoolModal
        visible={isModalVisible}
        onClose={() => {
          setIsModalVisible(false);
        }}
        schoolList={schoolList || {}}
        selectedSchool={selectedSchool}
        changeSchool={changeSchool}
      />
    </Layout.Header>
  );
};

export default Header;
